export default __webpack_public_path__ + "static/media/agenda.8309e330.svg";